import {
  fetchShopDetailShopDetail,
  fetchBizoppDetailShopDetail,
  fetchBizoppBillAccount,
  fetchContractorDetailShopDetail,
  fetchBizoppUpdateTags,
  fetchDish,
  fetchPlatformList,
  fetchAllConfig,
  setContractSignType,
  bizoppPickIn,
  getSaleDataByShopId
} from '@/api'
import { isEmpty } from 'lodash-es'
export default {
  // 获取商家详情
  getShopDetail ({ commit, state }, params) {
    let {
      shopId,
      force = false
    } = params
    let detail = state.shopBaseDetail[shopId]
    if (!force && !isEmpty(detail)) {
      commit('updateCurrentShopDetail', { [shopId]: detail })
      return detail
    }
    return fetchShopDetailShopDetail({
      shopId
    }).then(res => {
      let detail = { [shopId]: res.data }
      commit('updateShopDetail', detail)
      commit('updateCurrentShopDetail', detail)
      return res.data
    })
  },

  // 获取商机详情
  getBizoppDetail ({ commit, state }, params) {
    let {
      shopId,
      force = false
    } = params
    let detail = state.bizoppDetail[shopId]
    if (!force && !isEmpty(detail)) {
      commit('updateCurrentBizoppDetail', { [shopId]: detail })
      return detail
    }
    return fetchBizoppDetailShopDetail({
      shopId
    }).then(res => {
      let detail = { [shopId]: res.data }
      commit('updateBizoppDetail', detail)
      commit('updateCurrentBizoppDetail', detail)
      return res.data
    })
  },

  // 获取商机账单信息
  getBizoppBillAccount ({ commit, state }, params) {
    let {
      shopId
    } = params
    return fetchBizoppBillAccount({
      shopId
    }).then(res => {
      commit('updateBizoppBillAccount', res.data)
      return res.data
    })
  },
  // 商家信息获取时的经营品类、银行信息、合作平台信息的公共接口
  getAllConfig ({ commit, state }, params) {
    let {
      shopId,
      locale,
      withBankList
    } = params
    let allConfig = state.allConfig[shopId]
    if (!isEmpty(allConfig)) {
      commit('updateCurrentAllConfig', { [shopId]: allConfig })
      return allConfig
    }
    return fetchAllConfig({
      locale,
      withBankList
    }).then(res => {
      let detail = { [shopId]: res.data }
      commit('updateAllConfig', detail)
      commit('updateCurrentAllConfig', detail)
      return res.data
    })
  },

  // 获取合同详情
  getContractorDetail ({ commit, state }, params) {
    let {
      shopId,
      contractorId
    } = params
    let detail = state.contractorDetail[shopId]
    if (!isEmpty(detail)) {
      commit('updateCurrentContractorDetail', { [shopId]: detail })
      return detail
    }
    return fetchContractorDetailShopDetail({
      contractorId
    }).then(res => {
      let detail = { [shopId]: res.data }
      commit('updateContractorDetail', detail)
      commit('updateCurrentContractorDetail', detail)
      return res.data
    })
  },

  // 选择合同类型
  setContractType ({ commit, state }, params) {
    let {
      shopId,
      signType
    } = params
    return setContractSignType({
      shopId,
      signType
    }).then(res => {
      return res.data
    })
  },

  // 标记问题门店
  bizoppUpdateTags ({ commit, state }, params) {
    let {
      shopId,
      tags
    } = params
    return fetchBizoppUpdateTags({
      shopId,
      tags
    }).then(res => {
      return res.data
    })
  },
  // 捡入商机
  async pickUpBizopp({ commit, state }, params) {
    let res = ''
    try {
      res = await bizoppPickIn({
        ...params
      })
    } catch (e) {
      console.log(e)
    }
    return res
  },
  // 获取门店涉及销售数据
  async getShopSaleData ({ commit, state }, params) {
    let res = {}
    try {
      res = await getSaleDataByShopId({
        ...params
      })
      commit('updateSaleData', res.data)
    } catch (e) {
      console.log(e)
    }
  }
}
